// Stylesheets
import './assets/scss/site.scss';

import {fixSvgIntrinsicSizing} from './assets/modules/fixSvgIntrinsicSizing';
import {hover} from './assets/modules/hover';
import {navTrigger} from './assets/modules/navTrigger';
import {header} from './assets/modules/header';
import {scrollNav} from './assets/modules/scrollNav';
import {lazyload} from './assets/modules/lazyload';
import {initPhotoSwipeFromDOM} from './assets/modules/photoswipe-init';
import {hero} from './assets/modules/hero';
import {Pjax} from 'pjax-api';
import {carousel} from './assets/modules/carousel';
import {movies} from './assets/modules/movies';

const init = () => {
  fixSvgIntrinsicSizing();
  header();
  scrollNav();
  hover();
  lazyload();
  hero();
  carousel();
  movies();
  initPhotoSwipeFromDOM('.js-pswp-container');
}

navTrigger();
init();

// new Pjax({
//   areas: [
//     '#nav, #site-name, #main',
//     'body'
//   ],
//   update: {
//     css: false,
//     script: false
//   }
// });
 
document.addEventListener('pjax:ready', function(e) {
  document.body.classList.remove('is-nav-active');
  init();
  //gtag('config', ga_code, {'page_path' : location.pathname});
});